<template>
    <div v-loading="loader">
        <div class="row">
            <div class="col-md-12">
                <div class="card buttonsDiv">
                    <el-checkbox class="correction-check" v-model="correction" v-on:change="getTableData()">Bez korekt
                    </el-checkbox>
                    <el-button v-for="monthNumber in months.length"
                               :class="{ 'el-button--primary': month == monthNumber-1 }"
                               @click="changeDatePeriod(monthNumber-1)">{{months[monthNumber-1]}}
                    </el-button>
                    <el-date-picker v-on:change="dateChange"
                                    v-model="dateRange"
                                    type="daterange"
                                    placeholder="Wybierz zakres daty"
                                    range-separator=","
                                    format="yyyy-MM-dd"
                                    change="loading">
                    </el-date-picker>
                    <json-excel class="el-button el-button--default"
                                :data="jsonData"
                                :fields1="json_fields1"
                                :fields2="json_fields2"
                                v-on:onPrepareExportData="prepareExportData"
                                :name="`raport_pitformat_${lic}_${excelDate}.xls`">Eksport do excela


                    </json-excel>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="card">
                    <declarations-table :sum="calculateSum(tableDataExeOnline, 'fills')"
                                        :sumRows="calculateRowSums(tableDataExeOnline, 'fills')"
                                        :dayDisplay="true" dataType="fills"
                                        title="Liczba wypełnień w podziale na deklaracje"
                                        subTitle="wersja instalacyjna + wersja online"
                                        :data="tableDataExeOnline"></declarations-table>
                </div>
            </div>
            <div class="col-md-6">
                <div class="card">
                    <declarations-table :sum="calculateSum(tableDataExeOnline, 'amounts')"
                                        :sumRows="calculateRowSums(tableDataExeOnline, 'amounts')"
                                        :dayDisplay="true" dataType="amounts"
                                        title="Kwoty 1% w podziale na deklaracje"
                                        subTitle="wersja instalacyjna + wersja online"
                                        :data="tableDataExeOnline"></declarations-table>
                </div>
            </div>
            <div class="col-md-6 ">
                <div class="card">
                    <declarations-table :sum="calculateSum(tableDataExe, 'amounts')"
                                        :sumRows="calculateRowSums(tableDataExe, 'amounts')"
                                        id="test2"
                                        :dayDisplay="true" dataType="amounts"
                                        title="Kwoty 1% w podziale na deklaracje" subTitle="wersja instalacyjna"
                                        :data="tableDataExe"></declarations-table>
                </div>
            </div>
            <div class="col-md-6">
                <div class="card">
                    <declarations-table :sum="calculateSum(tableDataOnline, 'amounts')"
                                        :sumRows="calculateRowSums(tableDataOnline, 'amounts')"
                                        id="test" :dayDisplay="true" dataType="amounts"
                                        title="Kwoty 1% w podziale na deklaracje" subTitle="wersja online"
                                        :data="tableDataOnline"></declarations-table>
                </div>
            </div>
            <div class="col-md-6 ">
                <div class="card">
                    <declarations-table :sum="calculateSum(tableDataExe, 'fills')"
                                        :sumRows="calculateRowSums(tableDataExe, 'fills')"
                                        :dayDisplay="true" dataType="fills"
                                        title="Liczba wypełnień w podziale na deklaracje" subTitle="wersja instalacyjna"
                                        :data="tableDataExe"></declarations-table>
                </div>
            </div>
            <div class="col-md-6 ">
                <div class="card">
                    <declarations-table :sum="calculateSum(this.tableDataOnline, 'fills')"
                                        :sumRows="calculateRowSums(tableDataOnline, 'fills')"
                                        :dayDisplay="true" dataType="fills"
                                        title="Liczba wypełnień w podziale na deklaracje" subTitle="wersja online"
                                        :data="tableDataOnline"></declarations-table>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
</style>
<script>
  import DeclarationsTable from 'src/components/UIComponents/DeclarationsTable.vue'
  import ApiLocalStorage from 'src/helpers/ApiLocalStorage'
  import moment from 'moment'
  import JsonExcel from 'components/UIComponents/JsonExcel.vue'

  export default {
    data () {
      return {
        jsonData: [],
        month: '',
        loader: false,
        tableDataExeOnline: [],
        tableDataExe: [],
        tableDataOnline: [],
        months: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj'],
        sumRows: [],
        dateRange: '',
        datePeriod: '',
        excelDate: '',
        correction: false,
        sum: {},
        json_fields1: {
          'Instalacyjna-kwoty': 8,
          'Instalacyjna-wypelnienia': 7,
          'Online-kwoty': 7,
          'Online-wypelnienia': 7,
          'Instalacyjna/Online-kwoty': 7,
          'Instalacyjna/Online-wypelnienia': 7
        },
        json_fields2: [
          'Dzien', 'PIT-28', 'PIT-36', 'PIT-36L', 'PIT-37', 'PIT-38', 'PIT-39', 'Suma',
          'PIT-28', 'PIT-36', 'PIT-36L', 'PIT-37', 'PIT-38', 'PIT-39', 'Suma',
          'PIT-28', 'PIT-36', 'PIT-36L', 'PIT-37', 'PIT-38', 'PIT-39', 'Suma',
          'PIT-28', 'PIT-36', 'PIT-36L', 'PIT-37', 'PIT-38', 'PIT-39', 'Suma',
          'PIT-28', 'PIT-36', 'PIT-36L', 'PIT-37', 'PIT-38', 'PIT-39', 'Suma',
          'PIT-28', 'PIT-36', 'PIT-36L', 'PIT-37', 'PIT-38', 'PIT-39', 'Suma'
        ]
      }
    },
    mounted () {
      this.loader = true
      this.changeDatePeriod(0)
    },
    computed: {
      lic () {
        return this.$store.getters.lic
      }
    },
    watch: {
      lic: function () {
        this.changeDatePeriod(this.month)
      }
    },
    components: {DeclarationsTable, JsonExcel},
    methods: {
      getTableData () {
        this.loader = true

        ApiLocalStorage.requestData('tableDec' + this.datePeriod + this.correction + this.lic, 'api/legacy/upo-dec', 'post', {
          'lic': this.lic,
          'period': this.datePeriod,
          'correction': this.correction
        }, 900000).then(response => {
          this.excelDate = this.datePeriod
          this.tableDataOnline = response.values.online
          this.tableDataExe = response.values.exe
          this.tableDataExeOnline = this.sumTables(this.tableDataExe, this.tableDataOnline)
          this.prepareExportData()
          setTimeout(() => {
            this.loader = false
          }, 1)
        })
      },
      dateChange (date) {
        this.changeDatePeriod(date, 1)
      },
      changeDatePeriod (date, range = false) {
        if (range === 1) {
          this.datePeriod = date
        } else {
          this.month = date
          let firstDay = new Date(new Date().getFullYear(), date, 1)
          let lastDay = new Date(new Date().getFullYear(), date + 1, 0)
          this.datePeriod = moment(firstDay).format('YYYY-MM-DD') + ',' + moment(lastDay).format('YYYY-MM-DD')
        }
        this.getTableData()
      },
      sumTables (exe, online) {
        let sumTable = []
        for (let i = 0; i < exe.length; i++) {
          sumTable[i] = {
            day: exe[i].day,
            fills: {
              'PIT-28': exe[i].fills['PIT-28'] + online[i].fills['PIT-28'],
              'PIT-36': exe[i].fills['PIT-36'] + online[i].fills['PIT-36'],
              'PIT-36L': exe[i].fills['PIT-36L'] + online[i].fills['PIT-36L'],
              'PIT-37': exe[i].fills['PIT-37'] + online[i].fills['PIT-37'],
              'PIT-38': exe[i].fills['PIT-38'] + online[i].fills['PIT-38'],
              'PIT-39': exe[i].fills['PIT-39'] + online[i].fills['PIT-39']
            },
            amounts: {
              'PIT-28': exe[i].amounts['PIT-28'] + online[i].amounts['PIT-28'],
              'PIT-36': exe[i].amounts['PIT-36'] + online[i].amounts['PIT-36'],
              'PIT-36L': exe[i].amounts['PIT-36L'] + online[i].amounts['PIT-36L'],
              'PIT-37': exe[i].amounts['PIT-37'] + online[i].amounts['PIT-37'],
              'PIT-38': exe[i].amounts['PIT-38'] + online[i].amounts['PIT-38'],
              'PIT-39': exe[i].amounts['PIT-39'] + online[i].amounts['PIT-39']
            }
          }
        }
        return sumTable
      },
      calculateRowSums (data, dataType) {
        let sumTable = []
        let i = 0
        data.forEach(value => {
          sumTable[i] = value[dataType]['PIT-28'] +
            value[dataType]['PIT-37'] + value[dataType]['PIT-36'] +
            value[dataType]['PIT-36L'] + value[dataType]['PIT-38'] +
            value[dataType]['PIT-39']
          i++
        })
        return sumTable
      },
      calculateSum (data, dataType) {
        let sum = {pit28: 0, pit36: 0, pit36l: 0, pit37: 0, pit38: 0, pit39: 0, summary: 0}
        data.forEach(value => {
          sum.pit28 += value[dataType]['PIT-28']
          sum.pit36 += value[dataType]['PIT-36']
          sum.pit36l += value[dataType]['PIT-36L']
          sum.pit37 += value[dataType]['PIT-37']
          sum.pit38 += value[dataType]['PIT-38']
          sum.pit39 += value[dataType]['PIT-39']
        })
        this.calculateRowSums(data, dataType).forEach(value => {
          sum.summary += value
        })
        return sum
      },
      prepareExportData () {
        let online = this.tableDataOnline
        let exe = this.tableDataExe
        let exeOnline = this.tableDataExeOnline
        let rowSumExeFills = this.calculateRowSums(this.tableDataExe, 'fills')
        let rowSumExeAmounts = this.calculateRowSums(this.tableDataExe, 'amounts')
        let rowSumOnlineFills = this.calculateRowSums(this.tableDataOnline, 'fills')
        let rowSumOnlineAmounts = this.calculateRowSums(this.tableDataOnline, 'amounts')
        let rowSumExeOnlineFills = this.calculateRowSums(this.tableDataExeOnline, 'fills')
        let rowSumExeOnlineAmounts = this.calculateRowSums(this.tableDataExeOnline, 'amounts')
        let sumAll = Object.values(this.calculateSum(this.tableDataExe, 'amounts'))
        sumAll = sumAll.concat(Object.values(this.calculateSum(this.tableDataExe, 'fills')))
        sumAll = sumAll.concat(Object.values(this.calculateSum(this.tableDataOnline, 'amounts')))
        sumAll = sumAll.concat(Object.values(this.calculateSum(this.tableDataOnline, 'fills')))
        sumAll = sumAll.concat(Object.values(this.calculateSum(this.tableDataExeOnline, 'amounts')))
        sumAll = sumAll.concat(Object.values(this.calculateSum(this.tableDataExeOnline, 'fills')))
        let dataAll = []
        for (let i = 0; i < this.tableDataExe.length; i++) {
          dataAll[i] = [
            exe[i].day, exe[i]['amounts']['PIT-28'], exe[i]['amounts']['PIT-36'], exe[i]['amounts']['PIT-36L'], exe[i]['amounts']['PIT-37'], exe[i]['amounts']['PIT-38'], exe[i]['amounts']['PIT-39'], rowSumExeAmounts[i],
            exe[i]['fills']['PIT-28'], exe[i]['fills']['PIT-36'], exe[i]['fills']['PIT-36L'], exe[i]['fills']['PIT-37'], exe[i]['fills']['PIT-38'], exe[i]['fills']['PIT-39'], rowSumExeFills[i],
            online[i]['amounts']['PIT-28'], online[i]['amounts']['PIT-36'], online[i]['amounts']['PIT-36L'], online[i]['amounts']['PIT-37'], online[i]['amounts']['PIT-38'], online[i]['amounts']['PIT-39'], rowSumOnlineAmounts[i],
            online[i]['fills']['PIT-28'], online[i]['fills']['PIT-36'], online[i]['fills']['PIT-36L'], online[i]['fills']['PIT-37'], online[i]['fills']['PIT-38'], online[i]['fills']['PIT-39'], rowSumOnlineFills[i],
            exeOnline[i]['amounts']['PIT-28'], exeOnline[i]['amounts']['PIT-36'], exeOnline[i]['amounts']['PIT-36L'], exeOnline[i]['amounts']['PIT-37'], exeOnline[i]['amounts']['PIT-38'], exeOnline[i]['amounts']['PIT-39'], rowSumExeOnlineAmounts[i],
            exeOnline[i]['fills']['PIT-28'], exeOnline[i]['fills']['PIT-36'], exeOnline[i]['fills']['PIT-36L'], exeOnline[i]['fills']['PIT-37'], exeOnline[i]['fills']['PIT-38'], exeOnline[i]['fills']['PIT-39'], rowSumExeOnlineFills[i]
          ]
        }
        for (let i = 0; i < dataAll.length; i++) {
          for (let j = 0; j < dataAll[i].length; j++) {
            dataAll[i][j] = this.numberFormatter(dataAll[i][j])
          }
        }
        for (let i = 0; i < sumAll.length; i++) {
          sumAll[i] = this.numberFormatter(sumAll[i])
        }
        sumAll.splice(0, 0, 'Suma')
        dataAll.push(sumAll)
        this.jsonData = dataAll
      }
    }
  }
</script>
<style lang="scss" scoped>
    .correction-check {
        padding-top: 20px;
        float: left;
    }
</style>



// WEBPACK FOOTER //
// DeclarationsStats.vue?607f0190